import moment from 'moment-timezone';
import storage from './storage';

export const formatDate = (inpDate) => {
    let convertedDate = new Date(inpDate);
    let month = convertedDate.getMonth() + 1;
    let day = convertedDate.getDate();
    let year = convertedDate.getFullYear();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    let shortDate = `${day}-${month}-${year} 00:00:00`;

    return shortDate;
};

export const formatDateTime = (inpDate) => {
    let convertedDate = new Date(inpDate);
    let month = convertedDate.getMonth() + 1;
    let day = convertedDate.getDate();
    let year = convertedDate.getFullYear();
    let hour = convertedDate.getHours();
    let minute = convertedDate.getMinutes();
    let seconds = convertedDate.getSeconds();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    let shortDate = `${day}-${month}-${year} ${hour}:${minute}:${seconds}`;

    return shortDate;
};

export const statusOptions = [
    { name: 'Active', code: 'Active' },
    { name: 'Inactive', code: 'Inactive' },
    { name: 'Lock', code: 'Lock' },
    { name: "Closed", code: "Closed" },
];

export const userRolesOptions  = [
    { name: 'System Admin', code: 'SystemAdmin' },
    { name: 'System User', code: 'SystemUser' },
    { name: 'System Support User', code: 'SystemSupportUser' },
];

export const eventTypeOptions = [
    { name: 'FGM', code: 'FGM' },
    { name: 'MSM', code: 'MSM' },
    { name: 'PJO Addendum - PJOA', code: 'PJOA' },
    { name: 'Closed PJO - PJOC', code: 'PJOC' },
]

export const fileGroupOptions = [
    { name: 'FGPT', code: 'FGPT' },
    { name: 'FGPM', code: 'FGPM' },
    { name: 'FTRX', code: 'FTRX' },
    { name: 'MCT', code: 'MCT' },
    { name: 'EIT', code: 'EIT' },
    { name: 'ITT', code: 'ITT' },
    { name: 'RECT', code: 'RECT' },
    { name: 'ILT', code: 'ILT' },
    { name: 'IPRT', code: 'IPRT' },
    { name: 'CPNT', code: 'CPNT' },
    { name: 'CBT', code: 'CBT' },
    { name: 'FGM', code: 'FGM' },
    { name: 'MSM', code: 'MSM' },
    { name: 'PJO', code: 'PJO' },
    { name: 'PJOA', code: 'PJOA' },
    { name: 'PJOC', code: 'PJOC' },
    { name: 'PJO-XML', code: 'PJO-XML' }, 
    { name: 'PJOC-XML', code: 'PJOC-XML' }, 
    { name: 'PJOA-XML', code: 'PJOA-XML' }, 
];

export const logTypeOptions = [
    { name: 'FATAL', code: 'FATAL' },
    { name: 'ERROR', code: 'ERROR' },
    { name: 'WARN', code: 'WARN' },
    { name: 'INFO', code: 'INFO' },
    { name: 'DEBUG', code: 'DEBUG' },
    { name: 'TRACE', code: 'TRACE' },
];

export const fileTypeOptions = [
    { name: 'Inbound', code: 'inbound' },
    { name: 'Outbound', code: 'outbound' },
]

export const yesNoOptions = [
    { name: 'Yes', code: 'Y' },
    { name: 'No', code: 'N' },
]

export const trueFalseOptions = [
    { name: 'Yes', code: true },
    { name: 'No', code: false },
]

export const fileStatusOptions = [
    { name: 'Active', code: 'Active' },
    { name: 'Inactive', code: 'Inactive' },
    { name: 'Error', code: 'error' },
    { name: 'Pending', code: 'pending' },
    { name: 'Closed', code: 'Closed' },
    { name: 'Scheduled', code: 'Scheduled' },
];

export const tableNameOptions = [
    { name: 'Sys Store', code: 'sys_store' },
    { name: 'Sys Prop Config', code: 'sys_prop_config' },
    { name: 'Sys Apilog', code: 'sys_apilog' },
    { name: 'Sys App Logger', code: 'sys_applogger' },
    { name: 'Sys Error Code', code: 'sys_errorcodes' },
    { name: 'Integration File', code: 'integration_file' },
    { name: 'Integration File Uploadq', code: 'integration_file_uploadq' },
    { name: 'Integration File Pjo', code: 'integration_file_pjo' },
    { name: 'Integration File ITT', code: 'integration_file_itt' },
    { name: 'Integration File CMD', code: 'integration_file_cmd' },
    { name: 'Integration Outbound File', code: 'integration_file_outbound' },
    { name: 'Integration Outbound Log', code: 'integration_file_log' },
]

export const objtoarr = (ob) => {
    const { field, value, id, ...fields } = ob;
    const rest = Object.entries(fields).map(([field, value], id) => ({ field, value, id, }));
    return [...rest];
};

export const timeZonesOptions = moment.tz.names().map((tz) => {
    const offset = moment.tz(tz).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";
    const formattedOffset = `UTC${offset === 0 ? "" : `${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`}`;

    return { name: tz, code: formattedOffset };
});

export const selectedTimeZoneTemplate = (option, props) => {
    if (option) {
        return (
            <div className="flex align-items-center gap-10">
                <div>{option.name} - {option.code}</div>
            </div>
        );
    }

    return <span>{props.placeholder}</span>;
};

export const timeZoneOptionTemplate = (option) => {
    return (
        <div className="flex align-items-center gap-10">
            <div>{option.name} - {option.code}</div>
        </div>
    );
};


const convertToTimezone = (utcDateTime, timeZone, format) => {
    if (utcDateTime) { 

    }
    return moment.utc(utcDateTime, "DD-MM-YYYY HH:mm:ss").tz(timeZone).format(format);
};

export const dateTimeTemplate = utcDateTime => {
    if (!utcDateTime) { 
        return utcDateTime;
    }
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return convertToTimezone(utcDateTime, browserTimezone, "DD-MM-YYYY HH:mm:ss")
}

export const dateTemplate = utcDate => {
    if (!utcDate) { 
        return utcDate;
    }
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return convertToTimezone(utcDate, browserTimezone, "DD-MM-YYYY")
}

export const timeTemplate = utcTime => {
     if (!utcTime) { 
        return utcTime;
    }
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return convertToTimezone(utcTime, browserTimezone, "HH:mm:ss")
}

export const filterMenuByPermissions = (menuItems, userPermissions) => {
    return menuItems
        .map(item => {
            // If this item has children, filter them too
            if (item.children && Array.isArray(item.children)) {
                const filteredChildren = item.children.filter(child => userPermissions.includes(child.key));
                
                // If the parent key is allowed or any child is allowed, keep the parent
                if (userPermissions.includes(item.key) || filteredChildren.length > 0) {
                    return {
                        ...item,
                        children: filteredChildren
                    };
                }

                // Exclude item if not allowed
                return null;
            } else {
                // No children, just check the key
                return userPermissions.includes(item.key) ? item : null;
            }
        })
        .filter(Boolean); // remove nulls
};

export const isPermissionCodeValid = (code) => {
  const parsedUserDetails = JSON.parse(storage.get('userDetails'))
  return parsedUserDetails?.permissions?.includes(code);
};